import { styled } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemesProvider, ToastProvider, dayjs } from "@synota-io/synota-shared-ui";
import { PropsWithChildren, ReactNode } from "react";
import { HttpProvider } from "./api/http/HttpProvider";
import { AuthProvider } from "./api/auth/AuthProvider";
import { keepPreviousData, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "dayjs/plugin/timezone";

const RootDiv = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  width: "100%",
  height: "100%",
  display: "flex",
  overflow: "hidden",
}));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      placeholderData: keepPreviousData,
    },
    mutations: {},
  },
});

type SharedUiCompatibleNode = Exclude<ReactNode, bigint>;

export function AppProvider({ children }: PropsWithChildren<{ children: SharedUiCompatibleNode }>) {
  const rootDiv = (
    <LocalizationProvider dateAdapter={AdapterDayjs} dateLibInstance={dayjs}>
      <ToastProvider>{children}</ToastProvider>
    </LocalizationProvider>
  );

  return (
    <QueryClientProvider client={queryClient}>
      <ThemesProvider>
        <HttpProvider>
          <AuthProvider>
            <ToastProvider>
              <RootDiv>{rootDiv}</RootDiv>
            </ToastProvider>
          </AuthProvider>
        </HttpProvider>
      </ThemesProvider>
    </QueryClientProvider>
  );
}
